export enum UserRole {
  USER_IS_RECRUITING = 'USER_IS_RECRUITING',
  USER_IS_RECEIVER = 'USER_IS_RECEIVER',
}
